const SiteTagFields = [
	{
		type: 'Object',
		description: 'Site global optimization settings',
		name: 'rlvBooster',
		fields: [
			{
				type: 'Number',
				description: 'Percentage of users for non-optimized reference group',
				name: 'refPercentage',
				isRequired: true,
				defaultValue: 10,
				props: { between: { low: 0, high: 100 } },
			},
			{
				type: 'Boolean',
				name: 'prefetch',
				description: 'Prefetching on page load of optimal values',
				defaultValue: true,
			},
			{
				type: 'String',
				name: 'lsUsage',
				description: 'Local storage usage for history',
				defaultValue: 'cmp',
				isRequired: true,
				hasOptions: true,
				options: [
					{
						name: 'cmp',
						label: 'When permitted by Consent Management Platform (CMP)',
					},
					{
						name: 'cmp_none',
						label: 'When permitted by CMP, or CMP not available',
					},
					{
						name: 'always',
						label: 'Always',
					},
					{
						name: 'never',
						label: 'Never',
					},
				],
			},
			{
				type: 'Boolean',
				name: 'useCachedConsent',
				description: 'Cache last consent value',
				defaultValue: true,
				shouldHide: (__, ___, { lsUsage }) => lsUsage.value.split('_')[0] !== 'cmp',
				props: {
					help: 'Enable to be able to start prefetching before CMP is available',
				},
			},
			{
				type: 'Number',
				description: 'Never prefetch optimization-settings when cached age is less than (seconds)',
				name: 'minReloadSec',
				isRequired: true,
				defaultValue: 0,
			},
		],
	},
];

const PbConfigTagFields = [
	{
		type: 'Object',
		description: 'Per prebid config optimization settings',
		name: 'rlvBooster',
		fields: [
			{
				type: 'Number',
				name: 'prefetchDelay',
				description: 'Max auction delay when prefetching optimal values',
				defaultValue: 0,
			},
			{
				type: 'Number',
				name: 'normalDelay',
				description: 'Max auction delay when NOT prefetching optimal values',
				defaultValue: 150,
			},
		],
	},
];

module.exports = {
	SiteTagFields,
	PbConfigTagFields,
};
